import { useState, useMemo, useEffect, useRef } from 'react';
import CommonLayout from '../../Component/CommonLayout';
import profileicon from '../../assets/icons/solar_square-academic-cap-2-outline.svg'
import profileicon2 from '../../assets/icons/solar_square-academic-cap-2-outline (1).svg'
import profileicon3 from '../../assets/icons/solar_documents-minimalistic-linear.svg'
import profileicon4 from '../../assets/icons/hugeicons_manager.svg'
import ProfileStatus from '../../Component/ProfileStatus';
import filtericon from '../../assets/icons/mage_filter-fill.svg'
import '../../assets/css/StudentDashboard.css'
import '../../assets/css/StudentShortDetails.css';
import SearchBar from '../../Component/SearchBar';
import AddNewStudentModal from '../../Component/Modals/AddNewStudentModal';
import { SuccessfulPopup } from '../../Component/Modals/SuccessfulPopup';
import Table from '../../Component/Table';
import image from '../../assets/Images/image.png';
import phone from '../../assets/icons/ic_round-phone.svg';
import whatsapp from '../../assets/icons/logos_whatsapp-icon.svg';
import adstatus from '../../assets/icons/statuspur.svg'
import adstatusred from '../../assets/icons/status-red.svg';
import tablelast from '../../assets/icons/tablelast.svg';
import edit from '../../assets/icons/editnew.svg';
import { StudentShortDetails } from './StudentShortDetails';
import { useNavigate } from 'react-router-dom';
import { getBlob, getData, patchData, UpdateDataFormWithJson } from '../../API/GlobalApi';
import { GenerateIDModal } from '../../Component/Modals/GenerateIDModal';
import { PhotoEditor } from '../../Component/PhotoEditor';
import { IDValidityModal } from '../../Component/Modals/IDValidityModal';
import { IDPreviewModal } from '../../Component/Modals/IDPreviewModal';
import confirmadicon from '../../assets/icons/confirm-admission.svg';
import exporticon from '../../assets/icons/export-data.svg';
import { Tooltip } from 'react-tooltip';
import checkgif from '../../assets/gif/successfullgif.gif';
import close from '../../assets/icons/close.svg';
import { Filter } from '../../Component/Filter/Filter';
import debounce from 'lodash.debounce';
import ViewAdmissionForm from '../../Component/Modals/AdmissionFormPrint';
import { AdmissionCancelModal } from '../../Component/Modals/CanceledAdmissionModal';
import ConfirmationModal from '../../Component/Modals/ConfirmationModal';
import Notifier from '../../Utils/notify';
import { ShowStudentMissingDocumentsModal } from '../../Component/Modals/ShowStudentMissingsDocumentsModal';
import { highlightMatch } from '../../Utils/highlightSearchFunctions';
import { useTableFade } from '../../Utils/tableFadeHooks';
import TableLoaderOverlay from '../../Utils/tableFadingLoader';
import TableSkeleton from '../../Utils/TableSkeleton.js';
import { GridToggleIcon } from '../../Utils/selectBoxStyle.js';
import { CaptureBiometricThumb } from '../../Component/Modals/StudentBiometric.js';
import { ActionMenu, getStudentActionMenuOptions } from './StudentMenuOptions.js';
import { copyToClipboard } from '../../Utils/copyToClipboard.js';
import SvgIcon from '../../assets/icons/bioMetricScanner.jsx';
import BulkPromoteModal from '../../Component/Modals/BulkPromoteModal.js';
import { useHasPermission } from '../../Utils/checkPermissions.js';
import { PERMS } from '../../Utils/permissionCodes.js';
const StudentDashboardPage = () => {
  const hasPermission = useHasPermission();
  const canBulkPromote = hasPermission(PERMS.CAN_PROMOTE_STUDENTS);
  const canRevokeCancellation = hasPermission(PERMS.CAN_CANCEL_ADMISSION);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [bulkPromoteOpen, setBulkPromoteOpen] = useState(false);
  const [submit, setsubmit] = useState(false);
  const [currentPage, setCurrentPage] = useState(0); // Starts from 0
  const [totalCount, setTotalCount] = useState(0);
  const [studentdata, setStudentsdata] = useState([]);
  const [studentid, setstudentid] = useState([]);
  const [selectedOrgDetails, setSelectedOrgDetails] = useState([]);
  const [getstudentsdataId, setgetstudentsdataId] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);

  const [basicdata, setbasicdata] = useState([]);
  const [academicdata, setacademicdata] = useState([]);
  const [docdata, setdocdata] = useState([]);
  const [officialdata, setofficialdata] = useState([]);
  const [idcardmodal, setidcardmodal] = useState(false);
  const navigate = useNavigate();
  const pageSize = 10;
  const [showToast, setShowToast] = useState(false);
  const [toastVariant, setToastVariant] = useState('success');
  const [toastMessage, setToastMessage] = useState('');
  const [status, setstatus] = useState();
  const [showEditor, setShowEditor] = useState(false);
  const [showvaliditymodal, setshowvaliditymodal] = useState(false);
  const [cardpreview, setcardpreview] = useState(false);
  const [capturedPhoto, setCapturedPhoto] = useState(null);
  const [paymentmodal, setpaymentmodal] = useState(null);
  const [percentage, setpercentage] = useState([]);
  const [currentStep, setCurrentStep] = useState(0);
  const [idcarddata, setidcarddata] = useState([]);
  const today = new Date().toISOString().split('T')[0];
  const [validtydata, setvaliditydata] = useState({
    fromdate: today,
    Todate: ''
  })
  const [selectedSession, setSelectedSession] = useState(null);
  const [imgurl, setimgurl] = useState('')
  const [fingerprints, setFingerprints] = useState([null, null, null]);
  const [mainnamehead, setmainnamehead] = useState('');
  const [registrationnumforhead, setregistrationnumforhead] = useState('');
  const [regMode, setregMode] = useState(false);
  const [generatedregno, setgeneratedregno] = useState('');
  const [filtermodal, setfiltermodal] = useState(false);
  const [filterQueryString, setFilterQueryString] = useState('');
  const [showCancelAdmissionModal, setShowCancelAdmissionModal] = useState(false)

  const displayToast = (message, variant = 'success') => {
    setToastMessage(message);
    setToastVariant(variant);
    setShowToast(true);

    setTimeout(() => setShowToast(false), 3000);
  };

  const [selectedValues, setSelectedValues] = useState({});
  const [booleanStatus, setBooleanStatus] = useState({
    provisional_fees_status: "",
    registration_status: ""
  });



  const handleFilterClick = () => {
    // onFilter(searchQuery); 
    setfiltermodal(true);
  };
  const openModal = () => {
    setIsModalOpen(true);
  };


  const closeModal = () => {
    setIsModalOpen(false);
    setIsEditMode(false);
    setidcardmodal(false);
    setFingerprints([null, null, null]);
    setCapturedPhoto();
    setCurrentStep(0); // Reset to first step
  };

  const openAdmisionCancelModal = () => {
    setShowCancelAdmissionModal(true)
  }
  const closeAdmissionCancelModal = () => {
    setShowCancelAdmissionModal(false)

  }
  const submitclose = () => {
    setsubmit(false);
  };

  // /api/v1/ 



  const { skipSpinnerRef, tableLoading, triggerTableLoading, stopTableLoading } = useTableFade();
  const [isExporting, setIsExporting] = useState(false);
  const handleExportExcel = async () => {
    if (isExporting) return;
    setIsExporting(true);
    try {
      const urlWithParams = filterQueryString
        ? `students/students/export/excel/?${filterQueryString}`
        : 'students/students/export/excel/';

      const blob = await getBlob(urlWithParams);

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'students_export.xlsx';
      document.body.appendChild(a);
      a.click();
      a.remove();
    } catch (error) {
      displayToast('❌ Excel export failed', 'danger');
    } finally {
      setIsExporting(false);
    }
  };
  const handleRowClick = async (userId, row) => {

    const token = window.localStorage.getItem("token");

    try {

      const response = await getData(`students/get-students/${userId}/`)
      setSelectedOrgDetails(response);
      // Save data in state or localStorage (depending on your use case)
      localStorage.setItem("selectedEmployeeData", JSON.stringify(response));


    } catch (error) {
      displayToast("❌ Error fetching employee data:", 'danger');
    }
  };


  const data = useMemo(() => {
    return studentdata?.map((emp) => {
      // Prefer the current placement (lag.academic_group.specialization.course)
      // and fall back to provisional_academic_group only when lag is null
      // (student still in pre-provisional-admission state). After a course
      // change, provisional_academic_group keeps the original course, so
      // reading from it would render the old course name in the list.
      const course =
        emp?.lag?.academic_group?.specialization?.course?.name
        || emp?.provisional_academic_group?.specialization?.course?.name
        || 'N/A';
      const year = '2022–25'; // You can derive it from admission year + course duration if needed
      const semester = emp.lag?.academic_group?.name || 'N/A';
      const section = emp.lag?.name || '';
      const semesterInfo = section ? `${semester} - ${section}` : semester;
      setstatus(emp.status)
      return {
        id: emp.user_id,
        name: `${emp.first_name || ''} ${emp.middle_name && emp.middle_name.toLowerCase() !== 'null' ? emp.middle_name : ''} ${emp.last_name || ''}`,
        email: emp.email || '',
        contacts: emp.contact_numbers || [],
        img: emp.profile_picture || null,
        status: emp.status,
        course,
        year,
        semester: semesterInfo,
        lag: emp.lag,
        status: emp.status,
        permanent_registration_number: emp.permanent_registration_number,
        fees_payment_status: emp.fees_payment_status,
        registration_status: emp.registration_status,
        provisional_fees_status: emp.provisional_fees_status,
        admission_status: emp.admission_status,
        student_configuration: emp.student_configuration,
        handleRowClick: handleRowClick
      };
    });
  }, [studentdata]);



  // const debouncedSearch = useMemo(
  //   () => debounce((query) => {
  //     setCurrentPage(0); // reset to first page
  //     fetchStudents({ page: 0, query }); // unified fetch function
  //   }, 200),
  //   [filterQueryString, selectedSession]
  // );






  const handleEditClick = (userId, row) => {
    setSelectedUserId(userId);
    setregistrationnumforhead(row?.original.permanent_registration_number);
    setmainnamehead(row.original.name);
    setstudentid(userId);
    setIsEditMode(true);
    setregMode(false);
    setIsModalOpen(true);
  };
  const handleregisClick = (userId, row) => {
    setSelectedUserId(userId);
    setregistrationnumforhead(row.original.permanent_registration_number);
    setmainnamehead(row.original.name);
    setstudentid(userId);
    setIsEditMode(true);
    setregMode(true);
    setIsModalOpen(true);
  };
  const handleStatus = async (row) => {
    const newStatus = !row.original.status;
    setstatus(newStatus)
    row.original.status = newStatus;
    const url = `students/update-student-status/${row.original.id}/`;
    const response = await patchData(url, { status: newStatus });

    if (response && !response.error) {
      displayToast('Status Updated successfully!', 'success');
      setRefreshKey(prev => prev + 1)

    } else if (response && response.error) {
      const errorMsg = response.error?.[0] || 'Error Updating Status.';
      displayToast(errorMsg, 'danger');
    } else {
      displayToast('Unexpected error occurred.', 'danger');
    }

  };
  const handlegenerateIdcard = async (id) => {
    let url = `students/get-student-attendance/${id}/`;
    let res = await getData(url);
    if (res) {
      setidcarddata(res);
    }

  }




  const [openAdmissionFormPrint, setOpenAdmissionFormPrint] = useState(false)
  const [selectedStudentPrintData, setSelectedStudentPrintData] = useState(null);


  const openAdmissionPrintFormModal = () => {
    setOpenAdmissionFormPrint(true);
  };

  const closeAdmissionPrintFormModal = () => {
    setOpenAdmissionFormPrint(false);
  };

  const handlePrintAdmissionForm = (rowData) => {
    console.log("data in ppritn admission form", rowData)
    setSelectedStudentPrintData(rowData);
    setOpenAdmissionFormPrint(true);
  };



  const handleCopyPaymentUrl = async (id) => {

    const res = await getData(`finance/student-payment-link/?student_id=${id}`)
    console.log("ress", res)
    if (res?.payment_link) {
      await navigator.clipboard.writeText(res.payment_link);
      Notifier.info("Got it! The payment link is copied — you can paste it anywhere to share.");
    } else {
      Notifier.error("No payment link found for this student.");
    }
  }

  const searchValue = new URLSearchParams(filterQueryString).get("search") || "";

  const [showCaptureBiometric, setShowCaptureBioMetric] = useState(false)

  const handleBioMetric = async (id, data) => {

    setShowCaptureBioMetric(true)
    let url = `students/get-student-attendance/${id}/`;
    let res = await getData(url);
    if (res) {
      setidcarddata(res);
    }
  }


  const columns = useMemo(
    () => [

      {
        Header: 'Img',
        accessor: 'img',
        Cell: ({ value }) => {
          const imageUrl = value ? value : image;
          return (
            <img
              src={imageUrl}
              alt="Profile"
              style={{ width: '40px', height: '40px', borderRadius: '8px', border: "1px solid #E9E9E9" }}
            />
          );
        },
      },
      {
        Header: "Student's Name / ID",
        accessor: 'name',
        Cell: ({ row }) => (
          <div
            style={{ cursor: 'pointer' }}
            onClick={() => handleRowClick(row.original.id, row)}
          >
            {/* <p style={{ textAlign: 'left', color: '#222F3E', fontWeight: 500, margin: 0 }}>
              {row.original.name}
            </p> */}
            <p
              style={{
                textAlign: "left",
                color: "#222F3E",
                fontWeight: 500,
                margin: 0,
              }}
              dangerouslySetInnerHTML={{
                __html: highlightMatch(
                  row.original.name?.toString() || "-",
                  searchValue
                ),
              }}
            />
            {/* <p style={{ textAlign: 'left', margin: 0 }}>{row.original.permanent_registration_number ? row.original.permanent_registration_number : '-'}</p> */}

            <p
              style={{
                textAlign: "left",
                color: "#222F3E",
                fontWeight: 500,
                margin: 0,
                textDecoration: 'underline'
              }}
              dangerouslySetInnerHTML={{
                __html: highlightMatch(
                  row.original.permanent_registration_number ? row.original.permanent_registration_number : '-',
                  searchValue
                ),
              }}
              onClick={() =>
                copyToClipboard(row.original.permanent_registration_number, "Reg No copied")
              }
            />


          </div>
        ),
      },
      {
        Header: 'Course',
        accessor: 'course',
        Cell: ({ row }) => (
          <div className="no-text-cursor">
            <p style={{ textAlign: 'left', color: '#222F3E', fontWeight: 500, margin: 0 }}>
              {row.original.course}
            </p>

          </div>
        ),
      },
      {
        Header: 'Sem/Section',
        accessor: 'semester',
        Cell: ({ row }) => (
          <div className="no-text-cursor">
            <p style={{ textAlign: 'left', color: '#222F3E', fontWeight: 500, margin: 0 }}>
              {row.original.semester}
            </p>
          </div>
        ),
      },

      {
        Header: 'Contacts',
        accessor: 'contacts',
        Cell: ({ row }) => {
          const contact = row.original.contacts.find(c => c.contact_type === 'Mobile') || row.original.contacts[0];
          const number = contact?.number || 'N/A';
          const isWhatsapp = contact?.is_available_on_whatsapp;

          return (
            <div className="no-text-cursor">
              <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                <img src={phone} alt="Phone" />
                {/* <p>{number}</p> */}
                <p
                  style={{
                    textAlign: "left",
                    color: "#222F3E",
                    fontWeight: 500,
                    margin: 0,
                  }}
                  dangerouslySetInnerHTML={{
                    __html: highlightMatch(
                      number,
                      searchValue
                    ),
                  }}
                />
              </div>
              {isWhatsapp && (
                <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                  <img src={whatsapp} style={{ width: '12px', height: '12px' }} alt="WhatsApp" />
                  {/* <p>{number}</p> */}
                  <p
                    style={{
                      textAlign: "left",
                      color: "#222F3E",
                      fontWeight: 500,
                      margin: 0,
                    }}
                    dangerouslySetInnerHTML={{
                      __html: highlightMatch(
                        number,
                        searchValue
                      ),
                    }}
                  />
                </div>
              )}
            </div>
          );
        },
      },
      {
        Header: 'Biometric',
        accessor: 'student_configuration',
        Cell: ({ row }) => {
          const config = row.original.student_configuration || {};
          const { finger_iso_1, finger_iso_2, finger_iso_3 } = config;

          // ✅ any one finger present
          const isAnyFingerPresent = !!(finger_iso_1 || finger_iso_2 || finger_iso_3);

          return (
            <div
              style={{ display: 'flex', alignItems: 'center', justifyContent: 'start' }}
              title={isAnyFingerPresent ? "Biometric Verified" : "Biometric Not Verified"}
            >
              {isAnyFingerPresent ? (
                <SvgIcon color="#2ECC71"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleBioMetric(row?.original?.id, row?.original);
                  }} />
              ) : (
                <SvgIcon
                  color="#F26621"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleBioMetric(row?.original?.id, row?.original);
                  }}
                />
              )}
            </div>
          );
        },
      }

      ,

      {
        Header: 'Action',
        Cell: ({ row }) => {
          const menuOptions = getStudentActionMenuOptions({
            student: row.original, // 👈 key point
            handleRowClick,
            handlegenerateIdcard,
            setidcardmodal,
            handlePrintAdmissionForm,
            handleOpenMissingDocumentModal,
            handleCopyPaymentUrl,
            handelAdmissionClose,
            handleRevokeCancellation,
            canRevokeCancellation,
            handleBioMetric
          });

          return (
            <div
              style={{
                display: 'flex',
                gap: '10px',
                alignItems: 'center',
              }}
            >
              {/* Status Toggle */}
              {row.original.permanent_registration_number &&
                row.original.admission_status !== 'Cancelled' && (
                  <div className="form-check form-switch custom-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      id="flexSwitchCheckDefault"
                      style={{ cursor: 'pointer' }}
                      checked={row.original.status}
                      onChange={() => handleStatus(row)}
                      title='Status'
                    />

                  </div>
                )}

              {/* Confirm Admission */}
              {!row.original.permanent_registration_number && (
                <img
                  src={confirmadicon}
                  style={{ cursor: 'pointer' }}
                  alt="Confirm Admission"
                  onClick={() => handleregisClick(row.original.id, row)}
                  data-tooltip-id="admission-tip" data-tooltip-content="Confirm Admission"
                  title='Confirm Admission'
                />
              )}

              {/* Edit */}
              {row.original.permanent_registration_number &&
                row.original.admission_status !== 'Cancelled' && (
                  <img
                    src={edit}
                    style={{ cursor: 'pointer' }}
                    alt="Edit"
                    title="Edit details"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleEditClick(row.original.id, row);
                    }}
                  />
                )}


            </div>
          );
        },
      }



    ],
    [searchValue]
  );


  const handlePageChange = (data) => {
    const selectedPage = data.selected;
    triggerTableLoading();
    setCurrentPage(selectedPage);
  };



  const [sessions, setSessions] = useState([]);

  const getSessions = async () => {
    const response = await getData("academics/academic-years/");

    const options = response?.map((session) => ({
      value: session.id,
      label: session.name,
      is_current: session.is_current,
    }));
    setSessions(options);
    // const currentSession = options.find((opt) => opt.is_current);
    // if (currentSession) {
    //   setSelectedSession(currentSession);
    // }
  };

  useEffect(() => {
    getSessions();
  }, []);

  const pageCounts = Math.ceil(totalCount / pageSize);

  const [initialLoading, setInitialLoading] = useState(true);
  const [refreshKey, setRefreshKey] = useState(0);
  const [searchQuery, setSearchQuery] = useState(null);

  const fetchStudents = async (options = {}) => {
    const {
      page = 0,                  // 0-indexed page
      query = null,               // search query
      filters = filterQueryString // filter query string
    } = options;

    // if (!selectedSession) return;
    const academicYearId =
      typeof selectedSession === "number"
        ? selectedSession
        : selectedSession?.value;
    // Build query params
    const queryParams = new URLSearchParams(filters || "");
    // if (academicYearId) queryParams.set("academic_year_id", academicYearId);
    // Include search query if present
    // if (query !== null) queryParams.set("search", query);

    if (query?.trim()) {
      queryParams.set("search", query.trim());
    } else {
      queryParams.delete("search"); // 🔥 important
    }



    // Page is always 1-indexed for API
    queryParams.set("page", (page + 1).toString());
    const finalUrl = `students/get-students/?${queryParams.toString()}`;
    try {
      const response = await getData(finalUrl);
      const results = response?.results || [];
      setStudentsdata(results);
      setTotalCount(response?.count || 0);
      setgetstudentsdataId(results[0]?.user_id || null);
      // Reset selected organization if no results
      if (results.length === 0) {
        setSelectedOrgDetails(null); // <-- reset to empty state
      }
      // setFilterQueryString(queryParams.toString());
    } catch (err) {
      console.error("Error fetching students:", err);
      setStudentsdata([]);
      setTotalCount(0);
      setgetstudentsdataId(null);
      setSelectedOrgDetails(null); // reset on error too
    } finally {
      if (initialLoading) setInitialLoading(false);
    }
  };


  // useEffect(() => {
  //   fetchStudents({ page: currentPage })
  //     .finally(() => stopTableLoading()); // hide fade after completion
  // }, [currentPage, refreshKey]);


  useEffect(() => {

    fetchStudents({
      page: currentPage,
      query: searchQuery,
      filters: filterQueryString
    }).finally(() => stopTableLoading());
  }, [currentPage, searchQuery, filterQueryString]);

  // const debouncedSearch = useMemo(
  //   () => debounce((query) => {
  //     setCurrentPage(0); // reset to first page
  //     fetchStudents({ page: 0, query }); // unified fetch function
  //     // setSearchQuery(query); // 👈 store search
  //     setRefreshKey((prev) => prev + 1); // 👈 trigger API
  //   }, 200),
  //   [filterQueryString]
  // );

  const debouncedSearch = useMemo(
    () =>
      debounce((query) => {
        setCurrentPage(0);
        setSearchQuery(query); // ✅ only state update
      }, 200),
    []
  );


  // Clean up debounce on unmount
  useEffect(() => {
    return () => debouncedSearch.cancel();
  }, [debouncedSearch]);



  const [showStudentMissingDocumentsModal, setShowMissingDocumentsModal] = useState(false)
  const [selectedStudentMissingDocuments, setSelectedStudentMissingDocuments] = useState(null);
  const [missingDocs, setMissingDocs] = useState([]);
  const [loadingDocs, setLoadingDocs] = useState(false);

  const handleOpenMissingDocumentModal = async (id, row) => {
    const student = row.original;
    setSelectedStudentMissingDocuments(student);
    setShowMissingDocumentsModal(true);
    await fetchMissingDocs(student.user_id || student.id);
  };

  const fetchMissingDocs = async (userId) => {
    try {
      setLoadingDocs(true);
      setMissingDocs([]);
      const res = await getData(`students/validate-student-form-data/${userId}`);
      console.log("Missing Docs Response:", res);
      setMissingDocs(res?.errors || []);
    } catch (err) {
      Notifier.error("Error fetching missing documents.");
      console.error("Error fetching missing documents:", err);
    } finally {
      setLoadingDocs(false);
    }
  };

  useEffect(() => {
    const handleRowClick = async () => {
      if (!getstudentsdataId) return;
      const token = window.localStorage.getItem("token");
      if (!token) return;

      try {

        const response = await getData(`students/get-students/${getstudentsdataId}/`)
        setSelectedOrgDetails(response);
        localStorage.setItem("selectedEmployeeData", JSON.stringify(response));

      } catch (error) {
        displayToast("❌ Error fetching employee data:", 'danger');
      }
    };
    handleRowClick()
  }, [getstudentsdataId]);


  const [isLoadingFormDetails, setIsLoadingFormDetails] = useState(false);

  useEffect(() => {
    const fetchAllData = async () => {
      if (isEditMode && selectedUserId) {

        setIsLoadingFormDetails(true)
        try {
          const [
            basicData,
            academicData,
            officialData,
            uploadData
          ] = await Promise.all([
            getData(`students/student-onboarding-basic-details/${selectedUserId}/`),
            getData(`students/get-student-onboarding-qualification-details/${selectedUserId}/`),
            getData(`students/get-student-onboarding-official-details/${selectedUserId}/`),
            getData(`students/student-onboarding-documents-details/get-student-documents/?student_id=${selectedUserId}`),
          ]);

          if (basicData) setbasicdata(basicData);
          if (academicData) setacademicdata(academicData);
          if (officialData) setofficialdata(officialData);
          if (uploadData) setdocdata(uploadData);

        } catch (err) {
        }
        finally {
          setTimeout(() => setIsLoadingFormDetails(false), 300);
        }
      }
    };

    fetchAllData();
  }, [isEditMode, selectedUserId, currentStep]);

  const getallpercentages = async () => {
    let url = 'students/student-dashboard-percentages/';
    let res = await getData(url);
    if (res) {
      setpercentage(res)
    }
  }
  useEffect(() => {
    getallpercentages();
  }, [generatedregno])
  useEffect(() => {
    getallpercentages();
  }, [])
  const searchInputRef = useRef(null);

  useEffect(() => {
    if (searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, []);



  const [cancelStudentId, setCancelStudentId] = useState(null);
  const handelAdmissionClose = async (id, row) => {

    setCancelStudentId(id)
    setShowCancelAdmissionModal(true);
  };

  const [revokeStudent, setRevokeStudent] = useState(null);
  const [revokeReason, setRevokeReason] = useState('');
  const [revokeError, setRevokeError] = useState('');
  const [isRevoking, setIsRevoking] = useState(false);

  const handleRevokeCancellation = (student) => {
    setRevokeStudent(student);
    setRevokeReason('');
    setRevokeError('');
  };

  const closeRevokeModal = () => {
    setRevokeStudent(null);
    setRevokeReason('');
    setRevokeError('');
  };

  const confirmRevokeCancellation = async () => {
    if (!revokeReason.trim()) {
      setRevokeError('Revoke reason is required.');
      return;
    }
    setIsRevoking(true);
    const response = await UpdateDataFormWithJson(
      `students/admission-cancellation/?student_id=${revokeStudent.user_id}`,
      { revoke_cancellation_reason: revokeReason.trim() }
    );
    setIsRevoking(false);
    if (response?.error) {
      displayToast(response.error, 'danger');
      return;
    }
    displayToast('Admission cancellation revoked successfully', 'success');
    const studentId = revokeStudent.user_id;
    closeRevokeModal();
    fetchStudents({ page: currentPage });
    getallpercentages();
    handleRowClick(studentId);
  };

  const cancelledPercentage =
    percentage?.all_students > 0
      ? ((percentage.cancelled_students * 100) / percentage.all_students).toFixed(1)
      : "0.0";

  const menuOptions = selectedOrgDetails?.user_id
    ? getStudentActionMenuOptions({
      student: selectedOrgDetails,
      handleEditClick,
      handleRowClick,
      handlegenerateIdcard,
      setidcardmodal,
      handlePrintAdmissionForm,
      handleOpenMissingDocumentModal,
      handleCopyPaymentUrl,
      handelAdmissionClose,
      handleRevokeCancellation,
      canRevokeCancellation,
      handleBioMetric,
    })
    : [];


  return (
    <>

      <div style={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        overflow: "hidden",
        position: "relative",
      }}>

        {/* ── FIXED: Title + New Admission Button ── */}
        <div style={{ flexShrink: 0, padding: "0 12px" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <h2 className="main-heading">Students Dashboard</h2>
            <a
              href="/admissionform"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none" }}
            >
              <button className="add-btn">
                <span className="me-2">
                  <svg width="12" height="12" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20.4286 13.3537H12.5714V21.2108C12.5714 21.6276 12.4059 22.0273 12.1112 22.322C11.8165 22.6167 11.4168 22.7822 11 22.7822C10.5832 22.7822 10.1835 22.6167 9.88883 22.322C9.59413 22.0273 9.42857 21.6276 9.42857 21.2108V13.3537H1.57143C1.15466 13.3537 0.754961 13.1881 0.460261 12.8934C0.165561 12.5987 0 12.199 0 11.7822C0 11.3655 0.165561 10.9658 0.460261 10.6711C0.754961 10.3764 1.15466 10.2108 1.57143 10.2108H9.42857V2.35366C9.42857 1.93689 9.59413 1.53719 9.88883 1.24249C10.1835 0.947787 10.5832 0.782227 11 0.782227C11.4168 0.782227 11.8165 0.947787 12.1112 1.24249C12.4059 1.53719 12.5714 1.93689 12.5714 2.35366V10.2108H20.4286C20.8453 10.2108 21.245 10.3764 21.5397 10.6711C21.8344 10.9658 22 11.3655 22 11.7822C22 12.199 21.8344 12.5987 21.5397 12.8934C21.245 13.1881 20.8453 13.3537 20.4286 13.3537Z" fill="white" />
                  </svg>
                </span>
                New Admission
              </button>
            </a>
          </div>
        </div>

        {/* ── FIXED: Stat Cards ── */}
        <div style={{ flexShrink: 0, padding: "8px 12px" }}>
          <div className="dashboard-cards row" style={{ justifyContent: "space-around" }}>
            <ProfileStatus
              label="All Students" icon={profileicon}
              iconColor="#39886F" bgColor="#39886F0D" circleColor="#39886F"
              numbers={percentage.all_students} widths="220px"
            />
            <ProfileStatus
              label="Provisional Forms" icon={profileicon2}
              iconColor="#0E9DED" bgColor="#0E9DED0D" circleColor="#0E9DED"
              numbers={percentage.provisional_fees_count} widths="270px"
            />
            <ProfileStatus
              label="Admission Confirmed" icon={profileicon3}
              iconColor="#FF9B04" bgColor="#FF9B040D" circleColor="#FF9B04"
              numbers={percentage.registration_count} widths="300px"
            />
            <ProfileStatus
              label="Admission Cancelled" icon={profileicon4}
              iconColor="#2A62C8" bgColor="#2A62C80D" circleColor="#2A62C8"
              numbers={percentage.cancelled_students} widths="280px"
            />
          </div>
        </div>

        {/* ── FIXED: Search + Filter Bar ── */}
        <div style={{ flexShrink: 0, padding: "8px 12px" }}>
       <div className="row" style={{ alignItems: 'center' }}>
            <div className="col-md-6">
                <h4 className='text-primary'>All Students ({totalCount})</h4>
              </div>
                <div className="col-md-6"> 
            <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
              <SearchBar
                data={studentdata}
                onSearch={debouncedSearch}
                ref={searchInputRef}
                toggleOnIcon={<GridToggleIcon isDisabled={false} />}
                toggleOffIcon={<GridToggleIcon isDisabled={true} />}
                showToggle={true}
                placeholder="Search by Name, Reg. No, Phone No, Email.."
              />
              <button className="filter-btn" onClick={handleFilterClick} style={{ height: "43px" }}>
                <img src={filtericon} alt="filter" />
              </button>
              <button
                className="filter-btn"
                style={{
                  background: "white",
                  border: "1px solid #7F56DA",
                  height: "43px",
                  cursor: isExporting ? "not-allowed" : "pointer",
                  opacity: isExporting ? 0.7 : 1,
                }}
                onClick={handleExportExcel}
                disabled={isExporting}
                title={isExporting ? "Preparing Excel..." : "Export to Excel"}
                aria-busy={isExporting}
              >
                {isExporting ? (
                  <span className="spinner-border spinner-border-sm" role="status" style={{ color: '#7F56DA' }} />
                ) : (
                  <img src={exporticon} alt="export" />
                )}
              </button>
              {canBulkPromote && (
                <button
                  className="filter-btn"
                  title="Bulk promote students"
                  aria-label="Bulk promote students"
                  style={{
                    background: "white",
                    border: "1px solid #7F56DA",
                    height: "43px",
                    width: "43px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: 0,
                  }}
                  onClick={() => setBulkPromoteOpen(true)}
                >
                  {/* Stacked-arrows glyph: three students moving forward together. */}
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
                    <path d="M3.5 5h7.5M3.5 5l2.2-2.2M3.5 5l2.2 2.2" stroke="#7F56DA" strokeWidth="1.6" strokeLinecap="square" strokeLinejoin="miter"/>
                    <path d="M3.5 10h10.5M3.5 10l2.2-2.2M3.5 10l2.2 2.2" stroke="#7F56DA" strokeWidth="1.6" strokeLinecap="square" strokeLinejoin="miter"/>
                    <path d="M3.5 15h13.5M3.5 15l2.2-2.2M3.5 15l2.2 2.2" stroke="#7F56DA" strokeWidth="1.6" strokeLinecap="square" strokeLinejoin="miter"/>
                  </svg>
                </button>
              )}
            </div>
            </div>
          </div>
        </div>

        {/* ── SCROLLABLE BOTTOM: Table (left) + Details (right) ── */}
        <div style={{ display: "flex", flex: 1, minHeight: 0, overflow: "hidden", padding: "0 12px" }}>

          {/* LEFT: Table */}
          <div style={{
            flex: selectedOrgDetails?.user_id ? "0 0 75%" : "0 0 100%",
            maxWidth: selectedOrgDetails?.user_id ? "75%" : "100%",
            display: "flex",
            flexDirection: "column",
            minHeight: 0,
            overflow: "hidden",
            paddingRight: selectedOrgDetails?.user_id ? "12px" : "0",
            transition: "all 0.3s ease",
          }}>
            {initialLoading ? (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flex: 1 }}>
                <TableSkeleton rows={10} columns={7} showHeader={true} />
              </div>
            ) : data.length > 0 ? (
              <Table
                columns={columns}
                pageCounts={pageCounts}
                handlePageChange={handlePageChange}
                selectedOrgDetails={selectedOrgDetails}
                data={data}
                currentPage={currentPage}
              />
            ) : (
              <div style={{
                display: "flex", flexDirection: "column",
                alignItems: "center", justifyContent: "center",
                flex: 1, color: "#888", textAlign: "center",
              }}>
                No data available
              </div>
            )}
          </div>

          {/* RIGHT: Student Short Details */}
          {selectedOrgDetails?.user_id && (
            <div className="shortdetails" style={{
              flex: "0 0 25%",
              maxWidth: "25%",
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
            }}>
              <StudentShortDetails
                navigate={navigate}
                selectedOrgDetails={selectedOrgDetails}
                getstudentsdataId={getstudentsdataId}
                menuOptions={menuOptions}
              />
            </div>
          )}
        </div>

        <TableLoaderOverlay isLoading={tableLoading} />
      </div >


      <div>
        <AddNewStudentModal isOpen={isModalOpen} onClose={closeModal} setsubmit={setsubmit}
          basicdata={basicdata} setbasicdata={setbasicdata}
          academicdata={academicdata} setacademicdata={setacademicdata} docdata={docdata} setdocdata={setdocdata} officialdata={officialdata} setofficialdata={setofficialdata} setIsEditMode={setIsEditMode} isEditMode={isEditMode} selectedUserId={selectedUserId}
          registrationnumforhead={registrationnumforhead} mainnamehead={mainnamehead} setgeneratedregno={setgeneratedregno} regMode={regMode} currentStep={currentStep} setCurrentStep={setCurrentStep} isLoadingFormDetails={isLoadingFormDetails}
          fetchStudents={fetchStudents} currentPage={currentPage} />
      </div>
      {
        idcardmodal ? <GenerateIDModal isOpen={openModal} onClose={closeModal} selectedOrgDetails={selectedOrgDetails} setCapturedPhoto={setCapturedPhoto} capturedPhoto={capturedPhoto}
          setShowEditor={setShowEditor} setFingerprints={setFingerprints} fingerprints={fingerprints}
          setimgurl={setimgurl} setidcardmodal={setidcardmodal} setidcarddata={setidcarddata} idcarddata={idcarddata}
        /> : ''
      }
      {
        showEditor && (
          <PhotoEditor capturedPhoto={capturedPhoto} setCapturedPhoto={setCapturedPhoto} setShowEditor={setShowEditor} setshowvaliditymodal={setshowvaliditymodal} setpaymentmodal={setpaymentmodal}
            imgurl={imgurl} setimgurl={setimgurl} setFingerprints={setFingerprints} selectedOrgDetails={selectedOrgDetails} fingerprints={fingerprints} />
        )
      }
      {submit === true && regMode ? <SuccessfulPopup mainheading={'Registration Completed Successfully!'} submitclose={submitclose} generatedregno={generatedregno} /> : ''}
      {
        submit === true && !regMode ?
          <div className="modal-overlay">
            <div className="modal-content formlinkmodal" style={{ position: 'relative' }}>
              <div className="modal-header-content" style={{ display: 'flex', justifyContent: 'end' }}>
                <button className="close-btn" onClick={() => { setsubmit(false) }}><img src={close}></img></button>
              </div>
              <div className="modal-body" style={{ overflow: 'visible' }}>
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                  <img src={checkgif} style={{ width: '100px', height: '100px' }}></img>
                  {/* <p>Form link sent successfully!</p> */}
                  <p >Details Updated Successfully</p>
                </div>
              </div>
            </div>
          </div> : ''
      }

      {
        showToast && (
          <div
            className={`custom-toast toast align-items-center text-white bg-${toastVariant} border-0 position-fixed top-0 end-0 m-3`}
            role="alert"
            style={{
              display: 'block',
              minWidth: '300px',
              maxWidth: '400px',
              borderRadius: '8px',
              boxShadow: '0 6px 20px rgba(0,0,0,0.15)',
              fontSize: '15px',
              zIndex: 9999
            }}
          >
            <div className="d-flex">
              <div className="toast-body" style={{ padding: '12px 16px' }}>
                <strong>{toastVariant === 'success' ? '✅' : '❌'} </strong> {toastMessage}
              </div>
              <button
                type="button"
                className="btn-close btn-close-white me-2 m-auto"
                onClick={() => setShowToast(false)}
                aria-label="Close"
              ></button>
            </div>
          </div>

        )
      }

      {
        openAdmissionFormPrint && selectedStudentPrintData && (
          <ViewAdmissionForm
            isOpen={openAdmissionFormPrint}
            selectedStudentPrintData={selectedStudentPrintData}
            onClose={closeAdmissionPrintFormModal}
          />
        )
      }

      {canBulkPromote && (
        <BulkPromoteModal
          open={bulkPromoteOpen}
          onClose={() => setBulkPromoteOpen(false)}
          onSuccess={() => {
            // Refresh the student grid so promoted rows reflect their new class.
            fetchStudents({ page: currentPage });
          }}
        />
      )}


      <AdmissionCancelModal isOpen={showCancelAdmissionModal} onClose={closeAdmissionCancelModal} cancelStudentId={cancelStudentId} fetchStudents={fetchStudents} currentPage={currentPage} />

      <ConfirmationModal
        isOpen={!!revokeStudent}
        title="Revoke Cancellation"
        message={`Revoke admission cancellation of ${`${revokeStudent?.first_name || ''} ${revokeStudent?.last_name || ''}`.trim()}?`}
        onConfirm={confirmRevokeCancellation}
        onCancel={closeRevokeModal}
        isSubmitting={isRevoking}
        extraActions={
          <div style={{ width: '100%' }}>
            <label className="form-labell">Reason for Revoking <span className="astrisk">*</span></label>
            <textarea
              rows="3"
              className="fm-modal form-control"
              placeholder="Enter revoke reason"
              maxLength={255}
              value={revokeReason}
              onChange={(e) => setRevokeReason(e.target.value)}
            />
            {revokeError && <small className="text-danger">{revokeError}</small>}
          </div>
        }
      />


      {
        paymentmodal && <IDValidityModal setshowvaliditymodal={setshowvaliditymodal} setcardpreview={setcardpreview} setpaymentmodal={setpaymentmodal} setvaliditydata={setvaliditydata} validtydata
          ={validtydata} setFingerprints={setFingerprints} setCapturedPhoto={setCapturedPhoto} selectedOrgDetails={selectedOrgDetails} setidcarddata={setidcarddata} idcarddata={idcarddata} />
      }

      {cardpreview && <IDPreviewModal setcardpreview={setcardpreview} selectedOrgDetails={selectedOrgDetails} fingerprints={fingerprints} imgurl={imgurl} setFingerprints={setFingerprints} setCapturedPhoto={setCapturedPhoto} capturedPhoto={capturedPhoto} setidcarddata={setidcarddata} idcarddata={idcarddata} setRefreshKey={setRefreshKey} />}
      {
        filtermodal && <Filter setfiltermodal={setfiltermodal} setStudentsdata={setStudentsdata}
          filterQueryString={filterQueryString} setFilterQueryString={setFilterQueryString} setTotalCount={setTotalCount} setCurrentPage={setCurrentPage} fetchStudents={fetchStudents} onClose={() => setfiltermodal(false)}
          selectedValues={selectedValues}
          setSelectedValues={setSelectedValues}
          selectedSession={selectedSession}
          setSelectedSession={setSelectedSession}
          booleanStatus={booleanStatus}
          setBooleanStatus={setBooleanStatus}
          setSelectedOrgDetails={setSelectedOrgDetails} />
      }


      <ShowStudentMissingDocumentsModal
        isOpen={showStudentMissingDocumentsModal}
        onClose={() => setShowMissingDocumentsModal(false)}
        missingDocs={missingDocs}
        loading={loadingDocs}
        selectedStudentDetails={selectedStudentMissingDocuments}
      />

      <CaptureBiometricThumb isOpen={showCaptureBiometric} onClose={() => setShowCaptureBioMetric(false)}
        selectedOrgDetails={selectedOrgDetails} setCapturedPhoto={setCapturedPhoto} capturedPhoto={capturedPhoto}
        setShowEditor={setShowEditor} setFingerprints={setFingerprints} fingerprints={fingerprints}
        setimgurl={setimgurl} setidcardmodal={setidcardmodal} setidcarddata={setidcarddata} idcarddata={idcarddata}
        refreshStudents={fetchStudents} currentPage={currentPage} />
    </>
  );
};

export default StudentDashboardPage;
